/* =========================================================
   grade-badge.js
   Runs once site-wide via a delegated listener, since the
   grade badge can appear many times per page (product grids).
   ========================================================= */
(function () {
  if (window.__gradeBadgeInit) return;
  window.__gradeBadgeInit = true;

  function closeAll(except) {
    document.querySelectorAll('.grade-badge.is-open').forEach(function (el) {
      if (el !== except) {
        el.classList.remove('is-open');
        el.setAttribute('aria-expanded', 'false');
      }
    });
  }

  document.addEventListener('click', function (e) {
    var badge = e.target.closest('.grade-badge');

    if (!badge) {
      closeAll();
      return;
    }

    e.preventDefault();
    var isOpen = badge.classList.contains('is-open');
    closeAll(badge);
    badge.classList.toggle('is-open', !isOpen);
    badge.setAttribute('aria-expanded', String(!isOpen));
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeAll();
      return;
    }

    if (e.key === 'Enter' || e.key === ' ') {
      var badge = e.target.closest('.grade-badge');
      if (!badge) return;

      e.preventDefault();
      var isOpen = badge.classList.contains('is-open');
      closeAll(badge);
      badge.classList.toggle('is-open', !isOpen);
      badge.setAttribute('aria-expanded', String(!isOpen));
    }
  });
})();
